import React, {Component} from "react";
import PropTypes from "prop-types";

const GrudLogo = ({color, width}) => {

  return (
    <svg style={{width: width ? width : "30%"}}
         fill={color ? color : "#333"} id="Ebene_1"
         viewBox="0 0 3212 900">
      <g id="White">
        <g>
          <path className="st0" d="M2136.1,529.1V24.4h182.4v504.7c0,206.7-158.1,364.8-370.9,364.8c-212.8,0-370.9-158.1-370.9-364.8V24.4
			h182.4v504.7c0,115.5,85.1,200.6,188.5,200.6C2051,729.7,2136.1,644.6,2136.1,529.1z" />
          <path className="st0" d="M1347.2,553.4c0,0,152-66.9,152-249.3c0-155.7-121.6-279.7-291.8-279.7H868l89.9,164.2h243.4
			c66.9,0,115.5,48.6,115.5,115.5c0,60.8-48.6,109.4-115.5,109.4H999v164.2h171.9L1335,875.7h194.6L1347.2,553.4z" />
          <path className="st0" d="M2755.4,24.4h-316.2v555.3h182.4V188.6h133.8c145.9,0,255.4,115.5,255.4,261.4
			c0,145.9-115.5,261.4-255.4,261.4h-133.8v0h-182.4v164.2h316.2c249.3,0,437.8-188.5,437.8-425.6
			C3193.2,212.9,3004.7,24.4,2755.4,24.4z" />
          <path className="st0" d="M471.4,413.6v125H670V611C622.1,672.3,547.5,711.7,464,711.7c-144.3,0-261.7-117.4-261.7-261.7
			c0-144.3,117.4-261.7,261.7-261.7c80.3,0,152.2,36.4,200.2,93.4h212C809.8,119.4,650.2,4.9,464,4.9C218.1,4.9,18.8,204.2,18.8,450
			c0,245.8,199.3,445.1,445.1,445.1c189,0,380.4-129.7,415.5-317.4c0,0,0.5-58.4,0.5-61.5c0-0.5,0-102.7,0-102.7l-156.9,0H471.4z" />
        </g>
      </g>
    </svg>
  )
};

GrudLogo.propTypes = {
  color: PropTypes.string
};

export default GrudLogo;


// WEBPACK FOOTER //
// ./src/components/widgets/grudLogo/grudLogo.js